import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { staticBounceVariants } from "shared/components/animations";
const DWPlayerList = ({ users }) => {
  return (
    <div className="player-list">
      <div className="player-cards">
        {users?.map((user, index) => (
          <motion.div
            variants={staticBounceVariants}
            className="card"
            key={index}
          >
            <div className="player-img">
              <img src={user?.profile_image} className="img-fluid" alt="user" />
            </div>
            <p className="name mb-0">{user?.display_name}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default DWPlayerList;
